<!-- <app-no-internet *ngIf="is_offline"></app-no-internet>
<router-outlet *ngIf="!is_offline"></router-outlet>  -->
<router-outlet></router-outlet> 
<app-footer></app-footer>

<app-global-message></app-global-message>